module.exports = __webpack_public_path__ + "48354b8652d38cb4084f8ace945131ff.ttf";